import { camelCase } from "lodash-es";

import { getSortOptionFromURI } from "components/Filters/helpers";
import { SearchQueryOrderDirection } from "types/generated";

export const sortRows = <T>(searchParams: URLSearchParams, data: T[], initialSort: string): T[] => {
  const [sortOption] = getSortOptionFromURI(
    searchParams,
    initialSort,
    SearchQueryOrderDirection.Asc
  );

  const sorted = data.sort((a, b) => {
    const key = camelCase(sortOption.field) as keyof typeof a;
    const valueA = a[key];
    const valueB = b[key];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return sortOption.direction === SearchQueryOrderDirection.Asc
        ? valueA.localeCompare(valueB, undefined, { numeric: true })
        : valueB.localeCompare(valueA, undefined, { numeric: true });
    }

    if (typeof valueA === "number" && typeof valueB === "number") {
      return sortOption.direction === SearchQueryOrderDirection.Asc
        ? valueA - valueB
        : valueB - valueA;
    }
    return 0; // If types are not comparable, maintain original order
  });

  return sorted;
};
